export default __webpack_public_path__ + "static/media/treasurer_icon.7fa35208.svg";